import { render, staticRenderFns } from "./lost-found.vue?vue&type=template&id=18d546a0&"
import script from "./lost-found.js?vue&type=script&lang=js&"
export * from "./lost-found.js?vue&type=script&lang=js&"
import style0 from "./lost-found.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports